import {LiveQuestionnaire} from "socket_if"

export default {
  namespaced: true,
  state: {
    halls: [],
    main: {}
  },
  getters: {
    all: state => state.halls,
    main: state => state.main,
    getBySlug: state => slug => {
      return _.find(state.halls, ["slug", slug]) || {}
    },
    mainOrFirst: state => {
      let hall = state.main
      if (_.isEmpty(hall)) {
        hall = _(state.halls)
          .orderBy(["is_default", "sort_order"], ["asc", "asc"])
          .head()
      }

      return hall || {}
    },
    getLiveHalls: state => {
      return _.filter(state.halls, function(hall) {
        return LiveQuestionnaire.prototype.isVimeoLive.call(hall) && Boolean(hall.has_video_player)
      })
    }
  },
  mutations: {
    setHalls(state, halls) {
      state.halls = halls
    },
    setMain(state, main) {
      if (!main) return

      state.main = main
    }
  },
  actions: {
    async getHalls(context, slug) {
      await this._vm.$axios
        .get(`events/${slug}/halls`)
        .then(response => {
          const halls = response.data.halls
          context.commit("setHalls", halls)
          context.commit(
            "setMain",
            halls.find(hall => hall.is_default)
          )
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
